// Watch Lineup API wrapper. Mirrors the FastAPI router at /api/lineup.
// The queue is heterogeneous: creator posts (kind "post") and any other
// watchable item — movies, music videos, sermons (kind "external").
import api from "./api";

export async function getLineup() {
  const { data } = await api.get("/lineup");
  return data; // { items, count, updated_at }
}

export async function getLineupSuggestions() {
  const { data } = await api.get("/lineup/suggestions");
  return data; // { items, count }
}

export async function addToLineup(postId) {
  const { data } = await api.post("/lineup/add", { post_id: postId });
  return data; // { count, key, queued: true }
}

export async function addExternalToLineup(item) {
  // item: { title, youtube_id?, url?, poster?, source?, duration? }
  const { data } = await api.post("/lineup/add-external", item);
  return data; // { count, key, queued: true }
}

export async function removeFromLineup(key) {
  const { data } = await api.delete(`/lineup/${encodeURIComponent(key)}`);
  return data; // { count, key, queued: false }
}

export async function reorderLineup(order) {
  const { data } = await api.post("/lineup/reorder", { order }); // order = keys
  return data; // { count }
}

export async function clearLineup() {
  const { data } = await api.delete("/lineup");
  return data; // { count: 0 }
}
